<template>
  <div>
    <AccountMessages />
    <SystemMessages />
  </div>
</template>

<script setup lang="ts">
import AccountMessages from '@/components/ui/AccountMessages/AccountMessages.vue';
import SystemMessages from '@/components/ui/SystemMessages/SystemMessages.vue';
</script>
